export default function (token, config) {

  config.track.google_analytics = (typeof window.ga !== 'undefined');

  if (typeof window.exponea !== 'undefined') {

    return;
  
  }
   
  !(function (e, n, t, i, o, r) {

    function c(e) {

      if (typeof e !== 'number')
      {

        return e;

      } const n = new Date();

      return new Date(n.getTime() + 1e3 * e); 

    } const a = 4e3, s = 'xnpe_async_hide'; function p(e) {

      return e.reduce(function (e, n) {

        return e[n] = function () {

          e._.push([n.toString(), arguments]); 

        }, e; 

      }, { _: [] }); 

    } function m(e, n, t) {

      const i = t.createElement(n); i.src = e; i.crossOrigin = 'anonymous'; const o = t.getElementsByTagName(n)[0];

      return o.parentNode.insertBefore(i, o), i; 

    } function u(e) {

      return Object.prototype.toString.call(e) === '[object Date]'; 

    } r.target = r.target || 'https://api.exponea.com', r.file_path = r.file_path || r.target + '/js/exponea.min.js', o[n] = p(['anonymize', 'initialize', 'identify', 'update', 'track', 'trackLink', 'trackEnhancedEcommerce', 'getHtml', 'showHtml', 'showBanner', 'showWebLayer', 'ping', 'getAbTest', 'loadDependency', 'getRecommendation', 'reloadWebLayers']), o[n].notifications = p(['isAvailable', 'isSubscribed', 'subscribe', 'unsubscribe']), o[n].snippetVersion = 'v2.3.0', (function (e, n, t) {

      e[n]['_' + t] = {}, e[n]['_' + t].nowFn = Date.now, e[n]['_' + t].snippetStartTime = e[n]['_' + t].nowFn(); 

    }(o, n, 'performance')), (function (e, n, t, i, o, r) {

      e[o] = { sdk: e[i], sdkObjectName: i, skipExperiments: !!t.new_experiments, sign: t.token + '/' + (r.exec(n.cookie) || ['', 'new'])[1], path: t.target }; 

    }(o, e, r, n, i, RegExp('__exponea_etc__' + '=([\\w-]+)'))), (function (e, n, t) {

      m(e.file_path, n, t); 

    }(r, t, e)), (function (e, n, t, i, o, r, p) {

      if (e.new_experiments) {

        !0 === e.new_experiments && (e.new_experiments = {});
        let f, l = e.new_experiments.hide_class || s, _ = e.new_experiments.timeout || a, d = encodeURIComponent(r.location.href.split('#')[0]);
        e.cookies && e.cookies.expires && (typeof e.cookies.expires === 'number' || u(e.cookies.expires) ? f = c(e.cookies.expires) : e.cookies.expires.tracking && (typeof e.cookies.expires.tracking === 'number' || u(e.cookies.expires.tracking)) && (f = c(e.cookies.expires.tracking))), f && f < new Date() && (f = void 0);
        const x = e.target + '/webxp/' + n + '/' + r[t].sign + '/modifications.min.js?http-referer=' + d + '&timeout=' + _ + 'ms' + (f ? '&cookie-expires=' + Math.floor(f.getTime() / 1e3) : '');
        e.new_experiments.mode === 'sync' && r.localStorage.getItem('__exponea__sync_modifications__') ? (function (e, n, t, i, o) {

          t[o][n] = '<' + n + ' src="' + e + '"></' + n + '>', i.writeln(t[o][n]), i.writeln('<' + n + '>!' + o + '.init && document.writeln(' + o + '.' + n + '.replace("/' + n + '/", "/' + n + '-async/").replace("><", " async><"))</' + n + '>'); 

        }(x, n, r, p, t)) : (function (e, n, t, i, o, r, c, a) {

          r.documentElement.classList.add(e); const s = m(t, i, r); function p() {

            o[a].init || m(t.replace('/' + i + '/', '/' + i + '-async/'), i, r); 

          } function u() {

            r.documentElement.classList.remove(e); 

          } s.onload = p, s.onerror = p, o.setTimeout(u, n), o[c]._revealPage = u; 

        }(l, _, x, n, r, p, o, t));
      
      } 

    }(r, t, i, 0, n, o, e)), (function (e, n, t) {

      e[n].start = function (i) {

        i && Object.keys(i).forEach(function (e) {

          return t[e] = i[e]; 

        }), e[n].initialize(t); 

      }; 

    }(o, n, r)); 

  }(document, 'exponea', 'script', 'webxpClient', window, {
    target: 'https://api.exponea.com',
    token,
    ...config,
  }));
  /* global exponea */
  exponea.start();
  // Webpush initialisation
  window.onload = function () {

    exponea.notifications.isAvailable(function (status) {

      if (status) {

        exponea.notifications.isSubscribed(function (subscriptionActive, notificationsDenied) {

          if (!subscriptionActive && !notificationsDenied) {

            exponea.notifications.subscribe();
          
          }
        
        });
      
      }
    
    });
  
  };

}
